import { authAxios as authenticatedApi } from "../../lib/api";
export const fetchAnalytics = async (query = {}) =>
  authenticatedApi.post("/api/analytics/search", query);
export const createEvent = async (data) =>
  authenticatedApi.post("/api/analytics", data);
